export const systemVoices = [
    { alloy: 'David' },
    { echo: 'Alex' },
    { fable: 'Jordan' },
    { onyx: 'John' },
    { nova: 'Ava' },
    { shimmer: 'Alina' }
];
